export default __webpack_public_path__ + "static/media/giant.90e0fecf.png";